import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "detail-header" }
const _hoisted_2 = { class: "detail-header-top" }
const _hoisted_3 = { class: "detail-header-icon" }
const _hoisted_4 = { class: "detail-header-info" }
const _hoisted_5 = { class: "detail-header-title-row" }
const _hoisted_6 = { class: "detail-header-title" }
const _hoisted_7 = {
  key: 0,
  class: "detail-header-subtitle"
}
const _hoisted_8 = {
  key: 1,
  class: "detail-header-meta"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailHeader',
  props: {
    title: {},
    subtitle: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _renderSlot(_ctx.$slots, "badge")
        ]),
        (_ctx.subtitle)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.subtitle), 1))
          : _createCommentVNode("", true),
        (_ctx.$slots.meta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "meta")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})